import { IEnvironment } from './environment.type';
import { LogLevel } from '../../app/common/core/utilities/logging/log-level.enum';

export const stagingEnvironment: IEnvironment = {
  host: 'https://dashboard.availy.net',
  baseUrl: 'https://consignee-api-dev.starlinks-me.com',
  apiUrl: 'https://consignee-api-dev.starlinks-me.com/api/v1/',
  apiUrl_v1: 'https://consignee-api-dev.starlinks-me.com/api/v1',
  meetingUrl: 'https://meet.availy.net',
  hubUrl: 'https://consignee-api-dev.starlinks-me.com/hub/v1/notifications',
  logLevel: LogLevel.WARN,
  userAgent: 'starlinks-admin',
  userAgentSecret: 'OcSnYHaR2k0DyBo3WbJAIyZYrPT3iZRDv1ggPW7M-sk',
  useInMemoryClients: false,
  production: false
};

export const environment: IEnvironment = stagingEnvironment;
